import {
  UliPreviewInformationCriteria,
  UliPreviewInformationSmsCriteria,
} from '../models/uli-information-preview.model';

export class UliPreviewInformationLoad {
  public static readonly type = '[UliPreviewInformation] Load';

  constructor(public payload: UliPreviewInformationCriteria) {}
}

export class UliPreviewInformationSmsSend {
  public static readonly type = '[UliPreviewInformation] Send Sms';

  constructor(public payload: UliPreviewInformationSmsCriteria) {}
}

export class UliPreviewInformationInitialState {
  public static readonly type = '[UliPreviewInformation] Set Initial State';
}
